/* ─────────────────────────────────────────────────────────────
 * MaxMart chat widget — frontend logic.
 * Talks to your Express server via POST /chat.
 * ─────────────────────────────────────────────────────────── */

// Configure the backend URL. Override via <scr\ipt>window.MM_API='…'</scr\ipt>
// BEFORE this file loads, or edit here.
var API_URL = window.MM_API || 'https://api.maxmart.it/chat';

// Conversation history (sent to backend every turn). NOTE: must NOT be called `history` — shadows window.history.
var chatHistory = [];
var isOpen = false;
var isSending = false;
var proactiveShown = false;
var proactiveDismissed = false;

function mm$(id){ return document.getElementById(id); }

/* ── Helpers ─────────────────────────────────────────────── */
function hhmm(){ var d=new Date(); return String(d.getHours()).padStart(2,'0')+':'+String(d.getMinutes()).padStart(2,'0'); }
function esc(s){ return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

/* Render markdown-lite: [txt](url), **bold**, paragraphs, bullet lists */
function renderMd(text){
  var safe = esc(text);
  // links
  safe = safe.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function(_, t, u){
    return '<a href="'+u+'" target="_blank" rel="noopener">'+t+'</a>';
  });
  // bold
  safe = safe.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  // lists — group consecutive "- " lines
  var lines = safe.split('\n');
  var html = '';
  var inList = false, para = [];
  function flushPara(){ if(para.length){ html += '<p>'+para.join('<br>')+'</p>'; para=[]; } }
  for (var i=0;i<lines.length;i++){
    var ln = lines[i];
    if (/^\s*-\s+/.test(ln)){
      flushPara();
      if(!inList){ html += '<ul>'; inList = true; }
      html += '<li>'+ln.replace(/^\s*-\s+/, '')+'</li>';
    } else if (ln.trim() === ''){
      flushPara();
      if(inList){ html += '</ul>'; inList = false; }
    } else {
      if(inList){ html += '</ul>'; inList = false; }
      para.push(ln);
    }
  }
  flushPara();
  if(inList) html += '</ul>';
  return html;
}

/* Avatar SVG (for bubbles) */
function avatarHtml(size){
  size = size || 26;
  return '<div class="mm-avatar" style="width:'+size+'px;height:'+size+'px;border-radius:'+(size/2)+'px">'
    + '<svg width="'+(size*0.6)+'" height="'+(size*0.6)+'" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M5 13a7 7 0 0 1 14 0"/>'
    + '<rect x="5" y="10" width="14" height="10" rx="3"/>'
    + '<circle cx="10" cy="15" r="1.3" fill="#fff" stroke="none"/>'
    + '<circle cx="14" cy="15" r="1.3" fill="#fff" stroke="none"/>'
    + '<path d="M4 13v3M20 13v3"/>'
    + '<circle cx="20" cy="17.5" r="1.6" fill="#fff" stroke="none"/>'
    + '</svg></div>';
}

/* Append an AI bubble (also handles product cards) */
function appendAI(text, products){
  var body = mm$('mm-body');
  var wrap = document.createElement('div');
  wrap.className = 'mm-row';
  wrap.innerHTML =
    '<div class="av">'+avatarHtml(26)+'</div>' +
    '<div class="mm-buble-col">' +
      '<div class="mm-bubble ai">'+renderMd(text)+ productCardsHtml(products) +'</div>' +
      '<div class="mm-ts">'+hhmm()+'</div>' +
    '</div>';
  body.appendChild(wrap);
  // Hydrate any product images (avoids static-string src templates in source)
  wrap.querySelectorAll('img[data-img]').forEach(function(img){
    img.src = img.getAttribute('data-img');
    img.removeAttribute('data-img');
  });
  scrollToBottom();
}

function productCardsHtml(products){
  if (!products || !products.length) return '';
  var items = products.map(function(p){
    var okClass = p.available ? 'ok' : 'no';
    var okText  = p.available ? 'Disponibile' : 'Non disponibile';
    // Build img with data-img attr; we'll attach the real src via JS after innerHTML.
    var im = p.image ? '<img alt="" data-img="'+esc(p.image)+'">' : '';
    return '<a class="mm-card" href="'+esc(p.url)+'" target="_blank" rel="noopener"  style="text-decoration:none;color:inherit;cursor:pointer">' +
      '<div class="im">'+im+'</div>' +
      '<div class="mt">' +
        '<div><div class="nm">'+esc(p.title)+'</div>' +
        '<div class="pr">€ '+esc(p.price)+'</div></div>' +
        '<div class="rw">' +
          '<span class="av '+okClass+'"><span class="d"></span>'+okText+'</span>' +
          '<span class="go">Vedi</span>' +
          '<button class="mm-more" data-title="' + esc(p.title) + '" onclick="event.preventDefault();event.stopPropagation();">Dimmi di pi\u00f9</button>' +
        '</div>' +
      '</div>' +
      '</a>';
  }).join('');
  return '<div class="mm-cards">'+items+'</div>';
}

function appendUser(text){
  var body = mm$('mm-body');
  var wrap = document.createElement('div');
  wrap.className = 'mm-row user';
  wrap.innerHTML =
    '<div class="mm-buble-col">' +
      '<div class="mm-bubble u">'+esc(text).replace(/\n/g,'<br>')+'</div>' +
      '<div class="mm-ts">'+hhmm()+'</div>' +
    '</div>';
  body.appendChild(wrap);
  scrollToBottom();
}

function appendTyping(){
  var body = mm$('mm-body');
  var wrap = document.createElement('div');
  wrap.id = 'mm-typing-row';
  wrap.className = 'mm-row';
  wrap.innerHTML = '<div class="av">'+avatarHtml(26)+'</div><div class="mm-buble-col"><div class="mm-typing"><span></span><span></span><span></span></div></div>';
  body.appendChild(wrap);
  scrollToBottom();
}
function removeTyping(){ var t=mm$('mm-typing-row'); if(t) t.parentNode.removeChild(t); }

function appendError(msg){
  var body = mm$('mm-body');
  var d = document.createElement('div');
  d.className = 'mm-err';
  d.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16v.5"/></svg>' + esc(msg);
  body.appendChild(d);
  scrollToBottom();
}

function appendDisclaimer(){
  var body = mm$('mm-body');
  var d = document.createElement('div');
  d.className = 'mm-disclaimer';
  d.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F67424" stroke-width="1.75" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.5"/></svg> Max può fare errori. Verifica sempre informazioni importanti.';
  body.appendChild(d);
}

function scrollToBottom(){
  var body = mm$('mm-body');
  body.scrollTop = body.scrollHeight;
}

/* ── Welcome state ─────────────────────────────────────── */
function renderWelcome(){
  var body = mm$('mm-body');
  body.innerHTML = '';
  var time = document.createElement('div');
  time.className = 'mm-time';
  time.textContent = 'Oggi · ' + hhmm();
  body.appendChild(time);

  // Max intro bubble
  var greet = document.createElement('div');
  greet.className = 'mm-row';
  greet.innerHTML =
    '<div class="av">'+avatarHtml(26)+'</div>' +
    '<div class="mm-buble-col"><div class="mm-bubble ai">' +
    '<p><strong>Ciao! Sono Max</strong>, il tuo assistente MaxMart.</p>' +
    '<p>Posso aiutarti a trovare prodotti, verificare disponibilità, tracciare ordini o darti consigli tecnici.</p>' +
    '<p>Come posso esserti utile?</p>' +
    '</div><div class="mm-ts">'+hhmm()+'</div></div>';
  body.appendChild(greet);

  // Quick chips
  var chipsData = [
    {i:'🔍', t:'Trova un prodotto', q:'Vorrei trovare un prodotto'},
    {i:'📦', t:'Stato del mio ordine', q:'Qual è lo stato del mio ordine?'},
    {i:'🔧', t:'Consiglio tecnico', q:'Ho bisogno di un consiglio tecnico'},
    {i:'↩️', t:'Gestisci un reso', q:'Come faccio un reso?'},
  ];
  var chips = document.createElement('div');
  chips.className = 'mm-chips';
  chips.id = 'mm-welcome-chips';
  chipsData.forEach(function(c){
    var b = document.createElement('button');
    b.className = 'mm-chip';
    b.type = 'button';
    b.innerHTML = '<span>'+c.i+'</span>'+esc(c.t);
    b.onclick = function(){ send(c.q); };
    chips.appendChild(b);
  });
  body.appendChild(chips);
}

/* ── Open / close ─────────────────────────────────────── */
function openChat(){
  if (isOpen) return;
  isOpen = true;
  dismissProactive(true);
  mm$('mm-win').style.display = 'flex';
  mm$('mm-btn-wrap').style.display = 'none';
  var smileLauncher = document.getElementById('smile-ui-lite-launcher-frame-container'); if (smileLauncher) smileLauncher.style.display = 'none';
  if (chatHistory.length === 0) renderWelcome();
  setTimeout(function(){ mm$('mm-textarea').focus(); }, 80);
}
function closeChat(){
  isOpen = false;
  mm$('mm-win').style.display = 'none';
  mm$('mm-btn-wrap').style.display = 'block';
  var smileLauncher = document.getElementById('smile-ui-lite-launcher-frame-container'); if (smileLauncher) smileLauncher.style.display = 'block';
}

/* ── Proactive nudge ──────────────────────────────────── */
function showProactive(){
    if(!window.location.pathname.includes("/products/"))return;
  if (proactiveShown || proactiveDismissed || isOpen) return;
  proactiveShown = true;
  mm$('mm-proactive').style.display = 'block';
  mm$('mm-pulse1').style.display = 'block';
  mm$('mm-pulse2').style.display = 'block';
  mm$('mm-badge').style.display = 'grid';
}
function dismissProactive(soft){
  proactiveDismissed = true;
  mm$('mm-proactive').style.display = 'none';
  mm$('mm-pulse1').style.display = 'none';
  mm$('mm-pulse2').style.display = 'none';
  if (!soft) mm$('mm-badge').style.display = 'none';
}

// Kick off proactive after 30s
setTimeout(showProactive, 30000);

/* Click the proactive bubble to open the chat too */
mm$('mm-proactive').addEventListener('click', function(e){
  if (e.target.closest('.x')) return; // X button handles itself
  openChat();
});

/* ── Composer ─────────────────────────────────────────── */
function onKey(e){
  if (e.key === 'Enter' && !e.shiftKey){
    e.preventDefault();
    onSend(e);
  }
}
function onSend(e){
  if (e && e.preventDefault) e.preventDefault();
  var ta = mm$('mm-textarea');
  var text = ta.value.trim();
  if (!text || isSending) return false;
  ta.value = '';
  autosize();
  send(text);
  return false;
}

/* Auto-grow textarea */
function autosize(){
  var ta = mm$('mm-textarea');
  if (!ta.value.trim()) { ta.style.height = ''; return; }
  ta.style.height = '0';
  ta.style.height = Math.min(80, ta.scrollHeight) + 'px';
}
document.addEventListener('input', function(e){ if(e.target.id==='mm-textarea') autosize(); });

  


  


/* ── Main send function ───────────────────────────────── */
function send(text){
  if (isSending) return;
  isSending = true;
  mm$('mm-sendbtn').disabled = true;

  // Remove welcome chips if still there
  var chips = mm$('mm-welcome-chips');
  if (chips) chips.remove();

  // Append user bubble + push to chatHistory
  appendUser(text);
  chatHistory.push({ role: 'user', content: text });

  // Show disclaimer on first user message
  if (chatHistory.filter(function(m){return m.role==='user';}).length === 1){
    appendDisclaimer();
  }

  // Typing indicator
  appendTyping();

  fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ messages: chatHistory }),
  })
  .then(function(r){
    if (!r.ok) throw new Error('HTTP '+r.status);
    return r.json();
  })
  .then(function(data){
    removeTyping();
    if (data.error) throw new Error(data.error);
    var reply = data.reply || '';
    var products = data.products || [];
    appendAI(reply, products);
    chatHistory.push({ role: 'assistant', content: reply });
  })
  .catch(function(err){
    removeTyping();
    appendError('Non riesco a contattare l\'assistente ora. Riprova tra qualche istante o scrivici a assistenza@maxmart.it. (' + err.message + ')');
  })
  .finally(function(){
    isSending = false;
    mm$('mm-sendbtn').disabled = false;
    mm$('mm-textarea').focus();
  });
}
